import React from "react";

const DeliveryProgress = ({shipmentDetails}) => {

    const isProcessing = shipmentDetails?.shipmentStatus === 'PROCESSING';
    const isAfterProcessing = shipmentDetails?.shipmentStatus === 'DELIVERED' || shipmentDetails?.shipmentStatus === 'SHIPPED' || shipmentDetails?.shipmentStatus === 'SCHEDULED_FOR_DELIVERY'; 
    const isShipped = shipmentDetails?.shipmentStatus === 'SHIPPED';
    const isAfterShipped = shipmentDetails?.shipmentStatus === 'SCHEDULED_FOR_DELIVERY' || shipmentDetails?.shipmentStatus === 'DELIVERED';
    const isSchedulledForDelivery = shipmentDetails?.shipmentStatus === 'SCHEDULED_FOR_DELIVERY';
    const isDelivered = shipmentDetails?.shipmentStatus === 'DELIVERED';

    const setProccessingStyles = () => {
        return isProcessing ? "item-1-2 active" : isAfterProcessing ? "item-1-2" : "item-1-2 white";
    }

    const setShippedStyles = () => {
        return isShipped ? "item-2-2 active" : isAfterShipped ? "item-2-2" : "item-2-2 white";
    }

    const setScheduledForDeliveryStyles = () => {
        return isSchedulledForDelivery ? "item-2-1 active" : isDelivered ? "item-2-1" : "item-2-1 white";
    }

    const setDeliveredStyles = () => {
        return isDelivered ? "item-1-1" : "item-1-1 white";
    }


    return  <div className="delivery-progress">
                <div className={setDeliveredStyles()}>
                    <p>Доставена</p>
                    <div className={isDelivered ? "circle circle-pos dark" : "circle circle-pos"}></div>
                </div>
                <div className={setProccessingStyles()}>
                    <p>Обработва се</p>
                    <div className={isProcessing || isAfterProcessing ? "circle circle-pos dark" : "circle circle-pos"}></div>
                </div>
                <div className={setScheduledForDeliveryStyles()}>
                    <p style={{ maxWidth:'80px'}}>Пътува с куриер</p>
                    <div className={isSchedulledForDelivery || isDelivered ? "circle circle-pos dark" : "circle circle-pos"}></div>
                </div>
                <div className={setShippedStyles()} >
                    <p style={{ maxWidth:'80px'}}>Предадена на куриер</p>
                    <div className={isShipped || isAfterShipped ? "circle circle-pos dark" : "circle circle-pos"}></div>
                </div>
            </div>
}

export default DeliveryProgress;